import React, {FC} from "react"

import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"
import convertVideoUrlToEmbedUrl from "@irati/culture-hub/helpers/convertVideoUrlToEmbedUrl"

import {StyledImage, StyledImageTile, StyledContentWrapper, StyledVideo, StyledLink} from "./styled"
import Message from "./Message"

interface Props {
  companyNewsTile: CompanyNewsTile
}

const VideoTile: FC<Props> = ({companyNewsTile}) => {
  const {imageUrl, message, type, videoUrl} = companyNewsTile.config
  if (type !== CompanyNewsTileType.Video) {
    return null
  }

  const videoOutput = convertVideoUrlToEmbedUrl(videoUrl)

  return (
    <StyledImageTile>
      {imageUrl && (
        <StyledLink href={videoUrl} target="_blank" rel="noopener noreferrer">
          <StyledContentWrapper>
            <StyledImage imageUrl={imageUrl} />
          </StyledContentWrapper>
        </StyledLink>
      )}
      {!imageUrl && videoOutput && videoOutput.url && (
        <StyledContentWrapper>
          <StyledVideo>
            <iframe
              src={videoOutput.url}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={message}
              style={{
                position: "relative",
                height: "100%",
                width: "100%"
              }}
            />
          </StyledVideo>
        </StyledContentWrapper>
      )}
      <Message message={message} />
    </StyledImageTile>
  )
}

export default VideoTile
